export enum PayoutTabValues {
  All = 'all',
  Paid = 'paid',
  Failed = 'failed',
  Pending = 'pending',
}

export enum PayoutColumn {
  bank = 'Bank',
  ibanLast4 = '4 Digits',
  initiationDate = 'Initiation Date',
  amount = 'Amount',
  transferDate = 'TransferDate',
  status = 'Status',
  reconciliation = 'Reconciliation',
}
